import { Outlet } from 'react-router-dom';

// ==============================|| MINIMAL LAYOUT ||============================== //

const LandingLayout = () => (
  <>
        <Outlet future={{ v7_startTransition: true }} />
  </>
);

export default LandingLayout;
